/**
 * Welcome-offer cart helper (2026-10-10). Loaded on every page from layout/theme.liquid.
 *
 * Customers reported "the welcome code doesn't work". It did work - but only on carts
 * over the minimum (4,000 EGP, average order is ~2,600), and below it Shopify says
 * nothing useful: the cart page shows nothing at all, the drawer a generic
 * "cannot be applied". This script, while the visitor holds a live code from the popup
 * (localStorage, written by assets/welcome-offer.js):
 *   1. attaches the code to the cart once, so it applies by itself the moment the
 *      cart reaches the minimum - even if they closed the popup without the button;
 *   2. shows "add X more to unlock your code" in the cart drawer and on the cart page.
 * 2026-10-16: a Shop the Room add (look or single card) never auto-attaches the code.
 */
(function () {
  var KEY = 'cgs_welcome_offer_v1';
  var NOTE = 'wo-cart-note';

  function readState() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function writeState(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }

  var state = readState();
  if (!state || !state.code || !(state.expiresAt > Date.now())) return;

  var isAr = /^ar/i.test(document.documentElement.lang || '');
  var min = Number(state.min) || 4000; // ponytail: codes claimed before this release carry no min; 4000 is the live Worker value
  var amount = Number(state.amount) || 400;
  var code = String(state.code).toUpperCase();
  var bundle = false; // set the moment a Shop the Room add starts (its event fires before the request)

  function egp(n) {
    return Math.ceil(n).toLocaleString('en-US') + (isAr ? ' جنيه' : ' EGP');
  }

  var lastText = '';
  function render(cart) {
    var has = (cart.discount_codes || []).filter(function (c) {
      return String(c.code).toUpperCase() === code;
    })[0];
    var left = min - cart.items_subtotal_price / 100;
    var text = '';
    if (cart.item_count > 0 && left > 0) {
      text = isAr
        ? 'كودك ' + code + ': ضيف ' + egp(left) + ' كمان وخصم ' + egp(amount) + ' يتطبق لوحده (للطلبات فوق ' + egp(min) + ').'
        : 'Your code ' + code + ': add ' + egp(left) + ' more and ' + egp(amount) + ' off applies automatically (orders over ' + egp(min) + ').';
    } else if (cart.item_count > 0 && has && !has.applicable) {
      text = isAr
        ? 'كودك ' + code + ' مش متطبق على السلة دي. كلّمنا على واتساب ونساعدك.'
        : 'Your code ' + code + " isn't applying to this cart. Message us on WhatsApp and we'll sort it.";
    }
    lastText = text;
    document.querySelectorAll('.cart-drawer__summary, .cart-summary__inner').forEach(function (box) {
      var el = box.querySelector('.' + NOTE);
      if (!text) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('p');
        el.className = NOTE;
        el.setAttribute('role', 'status');
        el.style.cssText = 'margin:0 0 8px;padding:10px 12px;border-radius:12px;font-size:13px;line-height:1.45;' +
          'background:rgb(0 63 61 / 0.08);color:#003f3d;width:100%;box-sizing:border-box;';
        box.insertBefore(el, box.firstChild);
      }
      if (el.textContent !== text) el.textContent = text;
    });
  }

  var busy = false;
  function sync() {
    if (busy) return;
    busy = true;
    origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        // Attach once only: if the customer later removes it, respect that.
        if (!state.attached && cart.item_count > 0 && codes.length === 0) {
          state.attached = true;
          writeState(state);
          if (bundle) return cart; // Shop the Room bundle: no automatic discount, and it is not retried later
          return origFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: code })
          }).then(function (r) { return r.json(); });
        }
        return cart;
      })
      .then(render)
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  // Horizon re-renders the drawer/summary with morph, which drops our note - so
  // re-sync after any cart change and whenever the cart markup is swapped.
  var t;
  function soon() { clearTimeout(t); t = setTimeout(sync, 250); }
  // Themes and apps add to cart in different ways and not all of them emit an event the
  // first time (verified: the first PDP add fired nothing we could hear). Every one of
  // them goes through fetch, so watch that instead.
  var origFetch = window.fetch.bind(window);
  window.fetch = function (input) {
    var url = String((input && input.url) || input || '');
    var res = origFetch.apply(null, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      res.then(soon, soon);
    }
    return res;
  };
  ['cart:update', 'shopify:cart:lines-update', 'shopify:cart:discount-update'].forEach(function (e) {
    document.addEventListener(e, function (ev) {
      if (ev && ev.target && ev.target.closest && ev.target.closest('shop-the-room')) bundle = true;
      soon();
    });
  });
  new MutationObserver(function () {
    if (!lastText) return; // nothing to show: never poll on unrelated DOM churn
    var boxes = document.querySelectorAll('.cart-drawer__summary, .cart-summary__inner');
    for (var i = 0; i < boxes.length; i++) if (!boxes[i].querySelector('.' + NOTE)) return soon();
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();